import { Alert } from "antd";

const PrefillInfoAlert = () => {
  return (
    <Alert
      type="info"
      showIcon
      message="Prefilled for this class. You may edit these details as needed."
    />
  );
};

export default PrefillInfoAlert;
